export const globalConstants = {
	GET_BANK_REQUEST: 'GET_BANK_REQUEST',
	GET_BANK_SUCCESS: 'GET_BANK_SUCCESS',
	GET_BANK_FAILURE: 'GET_BANK_FAILURE',

	GET_SEARCH_CUSTOMER_REQUEST: 'GET_SEARCH_CUSTOMER_REQUEST',
	GET_SEARCH_CUSTOMER_SUCCESS: 'GET_SEARCH_CUSTOMER_SUCCESS',
	GET_SEARCH_CUSTOMER_FAILURE: 'GET_SEARCH_CUSTOMER_FAILURE',

	GET_USER_YAA_BY_ID_REQUEST: 'GET_USER_YAA_BY_ID_REQUEST',
	GET_USER_YAA_BY_ID_SUCCESS: 'GET_USER_YAA_BY_ID_SUCCESS',
	GET_USER_YAA_BY_ID_FAILURE: 'GET_USER_YAA_BY_ID_FAILURE',
}
